import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { OfferPagePromoLinks } from './OfferPagePromoLinks';
import actions from './OfferPagePromoLinks.actions';
import {
    getHeaderNames,
    getLocales,
    getLinks
} from './OfferPagePromoLinks.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderNames,
    locales: getLocales,
    links: getLinks
});

const OfferPagePromoLinksComponent = connect(
    function mapStateToProps(state, {onSave, showConstructor, showConstructorPromoCode, showConstructorPromoCodeList}) {
        return {
            ...mapStateToPropsSelectors(state),
            location: state.routingCompat,
            loading: state.links.loading,
            totalPages: state.links.total,
            onSave: onSave,
            showConstructor: showConstructor,
            showConstructorPromoCode: showConstructorPromoCode,
            showConstructorPromoCodeList: showConstructorPromoCodeList
        };
    },
    function mapDispatchToProps() {
        return {
            getLinks: actions.getLinks,
            deletePromoCode: actions.deletePromoCode
        };
    }
)(OfferPagePromoLinks);

export default OfferPagePromoLinksComponent;
